import React from 'react';
import { Navigate } from 'react-router-dom';

// Componente para proteger rutas que requieren autenticación
export const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" state={{ mensaje: 'Debes iniciar sesión para acceder a esta página.' }} replace />;
    }

    return children;
};

// Componente para proteger rutas que solo pueden acceder administradores
export const AdminRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('userRole');

    if (!token) {
        return <Navigate to="/login" state={{ mensaje: 'Debes iniciar sesión para acceder a esta página.' }} replace />;
    }

    if (userRole !== 'admin') {
        return <Navigate to="/login" state={{ mensaje: 'No tienes acceso autorizado a esta sección. Solo administradores pueden ingresar.' }} replace />;
    }

    return children;
};

